import Breadcrumb from "core/common/Breadcrumb/breadcrumb";
import React, { useEffect, useState } from "react";
// import ProfileCard from "../common/profileCard";
import InstructorSidebar from "../common/instructorSidebar";
import ViewStudentModal from "./ViewStudentModal";
import AddStudentModal from "./AddStudentModal";
import Table from "../../../core/common/dataTable/index";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/common/imageWithBasePath";
import { useDispatch } from "react-redux";
import { getAllUsers } from "utils/quizThunk";
import { createUser } from "utils/userThunk";
import toast from "react-hot-toast"; // optional, for success/failure messages

const StudentList = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState("");
  const [session, setSession] = useState("");
  const [examType, setExamType] = useState("");
  const [date, setDate] = useState("");
  const limit = 10;

  async function fetchStudent(pageNumber = 1, searchQuery = "") {
    const res = await dispatch(
      getAllUsers({
        page: pageNumber,
        limit,
        search: searchQuery,
        monthRange: session,
        course: examType,
        date
      })
    );
    const data = res?.payload;
    if (data?.success) {
      setStudents(data.users || []);
      setTotalPages(data.totalPages || 1);
      setTotal(data.totalUsers || 0);
    }
  }

  useEffect(() => {
    fetchStudent(page, search);
  }, [page, search, session, examType,date]);

  const [selectedStudent, setSelectedStudent] = useState(null);

  const handleAddStudent = async (values, { resetForm }) => {
    try {
      const result = await dispatch(createUser(values));
      if (createUser.fulfilled.match(result)) {
        toast.success("Student added successfully");
        fetchStudent(1, search); // Refresh student list
        resetForm(); // Clear the form
        closeModal("add_student"); // Hide the modal
      } else {
        toast.error(result?.payload?.message || "Failed to add student");
      }
    } catch (error) {
      console.error("Add Student API error:", error);
      toast.error("Something went wrong");
    }
  };

  const handleViewClick = (student) => {
    setSelectedStudent(student);
    const modal = document.getElementById("view_student");
    if (modal && window.bootstrap?.Modal) {
      try {
        const modalInstance =
          window.bootstrap.Modal.getInstance(modal) ||
          new window.bootstrap.Modal(modal);
        modalInstance.show();
      } catch (error) {
        console.error("Error showing view modal:", error);
      }
    }
  };

  const openAddModal = () => {
    const modal = document.getElementById("add_student");
    if (modal && window.bootstrap?.Modal) {
      const modalInstance =
        window.bootstrap.Modal.getInstance(modal) ||
        new window.bootstrap.Modal(modal);
      modalInstance.show();
    }
  };

  const closeModal = (modalId) => {
    const modal = document.getElementById(modalId);
    if (modal && window.bootstrap?.Modal) {
      const modalInstance = window.bootstrap.Modal.getInstance(modal);
      modalInstance?.hide();
    }
  };
  const dataSource = students.map((student) => ({
    key: student.id,
    name: `${student.first_name} ${student.last_name}`,
    email: student.email,
    phone: student.phone || "N/A",
    dob: student.date_of_birth
  ? student.date_of_birth.slice(0, 10)
  : "N/A",
    student,
    Img:
      student?.photo_path ||
      student?.csa_applications?.[0]?.photo_path ||
      student?.housekeeping_applications?.[0]?.photo_path,
  }));

  const columns = [
    {
      title: "Student Name",
      dataIndex: "name",
      render: (text, record) => (
        <div className="d-flex align-items-center">
          <Link
            to="#"
            className="avatar avatar-md avatar-rounded flex-shrink-0 me-2"
            onClick={() => handleViewClick(record.student)}
          >
            <ImageWithBasePath
              src={
                `https://indianairways.net/storage/${record?.Img}` ||
                "assets/img/user/user-01.jpg"
              }
              alt=""
            />
          </Link>
          <Link to="#" onClick={() => handleViewClick(record.student)}>
            <p className="fs-14 mb-0">{text}</p>
          </Link>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone",
    },
    {
      title: "Date of Birth",
      dataIndex: "dob",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => (
        <button
          className="btn btn-sm btn-outline-primary"
          onClick={() => handleViewClick(record.student)}
        >
          <i className="isax isax-eye"></i>
        </button>
      ),
    },
  ];
const getPageNumbers = (currentPage, totalPages) => {
  const pages = [];

  if (totalPages <= 6) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    pages.push(1);

    if (currentPage > 4) pages.push("...");

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - 3) pages.push("...");

    pages.push(totalPages);
  }

  return pages;
};

  return (
    <>
      <Breadcrumb title="Student List" />
      <div className="content">
        <div className="container">
          {/* <ProfileCard /> */}
          <div className="row">
            <InstructorSidebar />
            <div className="col-lg-9">
              <div className="card bg-light">
                <div className="card-body">
                  <div className="row align-items-center gy-3">
                    <div className="col-xl-8">
                      <h5 className="mb-2">Students</h5>
                      <p className="d-flex align-items-center fs-14 mb-0">
                        <i className="isax isax-user text-primary-soft me-2"></i>
                        {total} Students
                      </p>
                    </div>
                    <div className="col-xl-4 d-flex align-items-center justify-content-md-end ">
                      <button
                        className="btn btn-secondary rounded-pill"
                        // data-bs-toggle="modal"
                        onClick={openAddModal}
                        aria-label="Add new student"
                      >
                        Add Student
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12 d-flex flex-wrap justify-content-between">
                  {/* Session Filter */}
                  <div className="col-md-8 col-12 d-md-flex gap-2">
                    <div className="col-md-4 col-12 my-3 my-md-auto">
                      <select
                        className="form-select"
                        value={session}
                        onChange={(e) => setSession(e.target.value)}
                      >
                        <option value="">Select Session</option>
                        <option value="Jan-Mar">Jan - Mar</option>
                        <option value="Apr-Jun">Apr - Jun</option>
                        <option value="Jul-Sep">Jul - Sep</option>
                        <option value="Oct-Dec">Oct - Dec</option>
                      </select>
                    </div>

                    {/* Exam Type Filter */}
                    <div className="col-md-4 col-12 my-3 my-md-auto">
                      <select
                        className="form-select"
                        value={examType}
                        onChange={(e) => setExamType(e.target.value)}
                      >
                        <option value="">Select Exam Type</option>
                        <option value="CSA">CSA</option>
                        <option value="Loader / Housekeeping">Housekeeping</option>
                      </select>
                    </div>
                    <div className="col-md-3 col-12 my-3 my-md-auto">
                      <select
                        className="form-select"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                      >
                        <option value="">Select Year</option>
                        {Array.from({ length: 30 }, (_, i) => {
                          const year = new Date().getFullYear() - i;
                          return (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  {/* Search Box */}
                  <div className="position-relative col-md-4 col-12">
                    <input
                      type="text"
                      className="form-control ps-5"
                      placeholder="Search student..."
                      value={search}
                      onChange={(e) => {
                        setPage(1);
                        setSearch(e.target.value);
                      }}
                    />
                    <span
                      className="position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"
                      style={{ pointerEvents: "none" }}
                    >
                      <i className="bi bi-search"></i>
                    </span>
                  </div>
                </div>
              </div>

              <div className="card mt-3">
                <div className="card-body">
                  <Table
                    dataSource={dataSource}
                    columns={columns}
                    Search={false}
                  />
                  <div className="d-flex justify-content-end mt-3">
                    <nav>
                     <ul className="pagination">
  <li className={`page-item ${page === 1 ? "disabled" : ""}`}>
    <button className="page-link" onClick={() => setPage(page - 1)}>
      <i className="bi bi-chevron-left"></i>
    </button>
  </li>

  {getPageNumbers(page, totalPages).map((p, idx) => (
    <li
      key={idx}
      className={`page-item ${
        p === page ? "active" : ""
      } ${p === "..." ? "disabled" : ""}`}
    >
      {p === "..." ? (
        <span className="page-link">...</span>
      ) : (
        <button className="page-link" onClick={() => setPage(p)}>
          {p}
        </button>
      )}
    </li>
  ))}

  <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>
    <button className="page-link" onClick={() => setPage(page + 1)}>
      <i className="bi bi-chevron-right"></i>
    </button>
  </li>
</ul>

                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ViewStudentModal
        student={selectedStudent}
        closeModal={() => closeModal("view_student")}
      />
      <AddStudentModal
        handleSubmit={handleAddStudent}
        closeModal={() => closeModal("add_student")}
      />
    </>
  );
};

export default StudentList;
